const StarDark = () => {
    return <svg xmlns='http://www.w3.org/2000/svg' width='15.021' height='15.017' viewBox='0 0 15.021 15.017'>
        <path id='Icon_awesome-star' data-name='Icon awesome-star' d='M7.69.486,5.982,4.106l-3.823.582A.886.886,0,0,0,1.7,6.181L4.461,9l-.654,3.978a.845.845,0,0,0,1.214.921l3.42-1.878,3.42,1.878a.846.846,0,0,0,1.214-.921L12.422,9l2.766-2.816a.886.886,0,0,0-.463-1.493L10.9,4.106,9.192.486a.823.823,0,0,0-1.5,0Z' transform='translate(-0.931 0.501)' fill='#FCC628' stroke='#FCC628' strokeWidth='1' />
    </svg>
}

export default StarDark